import { PageViewEventLogger } from '@repo/tracking-service';
import { ResetPassword, SignBackButtonLayout } from '@repo/user-sign';
import { ReactElement } from 'react';

const ResetPasswordPage = () => {
  return (
    <>
      <ResetPassword />
      <PageViewEventLogger pageName={'reset-password'} />
    </>
  );
};

ResetPasswordPage.getLayout = (page: ReactElement) => <SignBackButtonLayout>{page}</SignBackButtonLayout>;

export default ResetPasswordPage;
